module.exports = __webpack_public_path__ + "img/arrow-left-24.0e802904.svg";